/* eslint-disable camelcase */
import { createSelector } from 'reselect';

export default createSelector(
  (state) => state.preset.payload,
  (payload) => {
    const { settings } = payload;

    if (!settings) return {};

    const presetSetting = settings.find((setting) => setting.code === 'PRESETS');

    if (!presetSetting) return {};

    const { id: settingId, user_settings } = presetSetting;

    if (!user_settings) {
      return { settingId, id: null, presets: null };
    }

    const { id, data } = user_settings;

    if (!data) {
      return { settingId, id, presets: null };
    }

    const { presets } = data;

    return { settingId, id, presets };
  },
);
